<template>
  <div class="period" v-if="data.display" style="position: relative; z-index: 999;">
    <h4>Период:</h4>
    <!--
    <img src="@/assets/images/icons/chevron-left.svg" alt="" @click="changeMonth(-1)">
    <span>{{ month.display }}</span>
    <img src="@/assets/images/icons/chevron-right.svg" alt="" @click="changeMonth(1)">
    -->
    <AnalitycsBtn
      @prevMonth="change(-1)"
      @nextMonth="change(1)"
      @changeType="type = $event; change();"
      :display="data.display"
      :type="type"
    />
  </div>
</template>

<script>
import moment from "moment";
import AnalitycsBtn from '@/components/functional/AnalitycsBtn'

export default {
  name: "Month",
  components: {AnalitycsBtn},
  mounted() {
    moment.locale('ru');
    this.change();
  },
  data() {
    return {
      data: {
        display: null,
        start: null,
        end: null,
      },
      type:'month'
    }
  },
  methods: {
    change(amount = 0) {
      if(this.type != 'all'){
        if (!this.data.start) this.data.start = moment().startOf(this.type).format('YYYY-MM-DD HH:ss:mm');
        if (!this.data.end) this.data.end = moment().endOf(this.type).format('YYYY-MM-DD HH:ss:mm');
        let start = moment(this.data.start, 'YYYY-MM-DD HH:ss:mm').add(amount, this.type).startOf(this.type);
        this.data = {
          display: {
            month: start.format('MMMM'),
            year: start.format('YYYY')
          },
          start: start.format('YYYY-MM-DD HH:ss:mm'),
          end: start.endOf(this.type).format('YYYY-MM-DD HH:ss:mm'),
        };
        this.$emit('change', this.data.start, this.data.end);
      }else{
        this.$emit('change', moment('2000', 'YYYY').format('YYYY-MM-DD HH:ss:mm'), moment().format('YYYY-MM-DD HH:ss:mm'));
      }

    },
  }
}
</script>

<style scoped lang="scss">
.period {
  padding: 15px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 10px;
  margin-bottom: 30px;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04));
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  h4 {
    font-weight: 600;
  }

  span {
    text-transform: capitalize;
  }

  img:hover {
    cursor: pointer;
    transition: .3s;
    transform: scale(1.3);
  }
}

@media screen and (max-width: 991px) {
  .period {
    width: auto;
    margin-left: -15px;
    margin-right: -15px;
    margin-bottom: 15px;
  }
}
</style>
